<template>
	<el-form :model="form" ref='form' :rules="rules">
	  <el-form-item label="账户名" :label-width="formLabelWidth" prop="username">
	    <el-input v-model="form.username" autocomplete="off"></el-input>
	  </el-form-item>
	  <el-form-item label="密码" :label-width="formLabelWidth" prop="password">
	    <el-input v-model="form.password" autocomplete="off" show-password></el-input>
	  </el-form-item>
	  <el-form-item label="确认密码" :label-width="formLabelWidth" prop="re_password">
	    <el-input v-model="form.re_password" autocomplete="off" show-password></el-input>
	  </el-form-item>
	  <el-form-item label="昵称" :label-width="formLabelWidth" prop="nick_name">
	    <el-input v-model="form.nick_name" autocomplete="off"></el-input>
	  </el-form-item>
	  <el-form-item label="邮箱" :label-width="formLabelWidth" prop="email">
	    <el-input v-model="form.email" autocomplete="off"></el-input>
	  </el-form-item>
	  <el-form-item v-if="form.id !=1" label="状态" :label-width="formLabelWidth" prop="status">
		  <el-switch
		                  v-model="form.status"
		                  active-color="#409EFF"
		                  inactive-color="#F56C6C"
		  							  :active-value="1"
		  							  :inactive-value="2"
		                />
	  </el-form-item>
	  <el-form-item label="角色" :label-width="formLabelWidth" prop="role_id">
	    <el-select v-model="form.role_id" placeholder="请选择角色">
	      <el-option v-for="item in roleData" :key="item.role_name" :label="item.role_name" :value="item.id"></el-option>
	    </el-select>
	  </el-form-item>
	  <el-form-item :label-width="formLabelWidth">
		  <span class="dialog-footer">
		    <el-button type="primary" @click="submit()">确 定</el-button>
		  </span>
	  </el-form-item>
	</el-form>
</template>

<script>
	export default{
		name:'AdminEdit',
		data(){
			return{
				list:[],
				loading: false,
				multipleSelection: [],
				dialogFormVisible: false,
				formLabelWidth: '120px',
				roleData:[],
				form:{
					username:'',
					password:'',
					re_password:'',
					nick_name:'',
					email:'',
					status:'',
					role_id:''
				},
				rules:{
					username:[{
						required: true,
						message: '用户名不能为空',
						trigger: 'blur'
					}],
					password:[{
						required: true,
						message: '密码不能为空',
						trigger: 'blur'
					}],
					re_password:[{
						required: true,
						message: '确认密码不能为空',
						trigger: 'blur'
					}],
					nick_name:[{
						required: true,
						message: '昵称不能为空',
						trigger: 'blur'
					}],
					email:[{
						required: true,
						message: '邮箱不能为空',
						trigger: 'blur'
					}],
					role_id:[{
						required: true,
						message: '角色必选',
						trigger: 'change'
					}],
				}
			}
		},
		methods:{
			getDetail(){
				this.httpPost({
					url:'/admin/admin/getDetail',
					data:{id:this.form.id}
				}).then((res)=>{
					this.setItem(this.form,res.data);
				})
			},
			getRole(){
				this.httpPost({
					'url':'/admin/role/role_list'
				}).then((re) => {
					  	let data = re.data
					  	// console.log(data)
					  	let temp = this.cloneObj(data);
					  	this.roleData = temp;
					  	this.loading = false;
					  
					  }).catch((err) => {
					  	this.loading = false;
					  })
			},
			submit(){
				this.$refs['form'].validate((valid)=>{
					if(valid){
						if(this.form.password != this.form.re_password) return this.$message.error('两次密码不一致！');
						this.updateAdmin();
					}else{
						console.log('error submit!')
						return false;
					}
				})
			},
			updateAdmin() {
			
			
			        let temp = this.cloneObj(this.form);
			
			        delete temp.re_password;
			
			        let id = this.$route.query.id;
			
			        console.log(id);
			
			        if (!id) id = '';
			
			
			        this.msgBoxAjax(
			          '提示',
			          '确定修改吗？',
			          "/admin/admin/admin_update?id=" + id,
			          temp).then((data) => {
			          // console.log(data);
			
			          if (data.code == 1) {
			            this.messageSuccess('提示', '操作成功，需要返回列表页面吗？').then(() => {
			
			              this.$router.go(-1);
			            });
			          }else{
			
			            this.messageCommon('错误',data.msg,'error');
			          }
			
			
			        });
			
			      },
		},
		created() {
			this.getRole();
			this.form.id = this.$route.query.id;
			if (this.form.id) this.getDetail(); this.rules.password = [];this.rules.re_password = [];
		}
	}
</script>

<style>
</style>
